
import OptimiserAPIService from '@/modules/optimiser/services/apiService'

export default class OptimiserModule {
  constructor() {
  }

  install(Vue) {
    // Services
    Vue.prototype.$apiService.optimiserService = new OptimiserAPIService(Vue.prototype.$api, Vue.prototype.$reportingApi)
  }

  getRoutes() {
    return [
      // Optimiser Configuration
      {
        path: '/optimiser/configuration',
        name: 'OptimiserConfiguration',
        component: () => import('@/modules/optimiser/views/optimiserConfiguration.vue'),
        meta: {
          requiresAuth: true,
          title: 'Optimiser Configuration',
          menuLink: '/optimiser/configuration',
          breadcrumbs: [
            { title: 'Home', link: '/'},
          ],
        }
      },
      // Optimiser Sheets
      {
        path: '/optimiser/sheets',
        name: 'OptimiserSheetList',
        component: () => import('@/modules/optimiser/views/optimiserSheetList.vue'),
        meta: {
          requiresAuth: true,
          title: 'Optimiser Sheets',
          menuLink: '/optimiser/sheets',
          breadcrumbs: [
            { title: 'Home', link: '/'}
          ],
        }
      },
      {
        path: '/optimiser/sheets/:id',
        name: 'OptimiserSheet',
        component: () => import('@/modules/optimiser/views/optimiserSheet.vue'),
        meta: {
          requiresAuth: true,
          title: 'Optimiser Sheet',
          menuLink: '/optimiser/sheets',
          breadcrumbs: [
            { title: 'Home', link: '/'},
            { title: 'Optimiser Sheets', link: '/optimiser/sheets'},
          ],
        }
      },
    ]
  }
}
